import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

export function formatDateToDDMMYYYY(dateInput) {
    if(!dateInput) return '-';
    const date = new Date(dateInput);
    
    if (isNaN(date)) {
      throw new Error("Invalid date input");
    }
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();
  
    return `${day}-${month}-${year}`;
  }


  dayjs.extend(customParseFormat);
  
  export function formatDateToDDMMYYYYWithTime12Hr(dateInput) {
      if (!dateInput) return '-';
  
      const date = dayjs(dateInput);
  
      if (!date.isValid()) {
          throw new Error("Invalid date input");
      }
  
      // Format: DD-MM-YYYY hh:mm:ss A (12-hour format with AM/PM)
      return date.format('DD-MM-YYYY hh:mm A');
  }
